import { jsx as _jsx } from "react/jsx-runtime";
import { DocumentPreview } from '../../../components/artifacts/document-preview';
import { SheetArtifactEditor } from '../../../components/artifacts/sheet-editor';
export const sheetArtifact = {
    kind: 'sheet',
    description: 'Work with tabular data using a simple markdown-table based sheet. Easy to swap out for richer grids later.',
    Preview: ({ title, content, isStreaming, onExpand, sourceAttachmentId, sourceUrl, contentType })=>/*#__PURE__*/ _jsx(DocumentPreview, {
            title: title,
            kind: "sheet",
            content: content,
            isStreaming: isStreaming,
            onExpand: onExpand,
            sourceAttachmentId: sourceAttachmentId,
            sourceUrl: sourceUrl,
            contentType: contentType
        }),
    Editor: ({ value, onChange, sourceAttachmentId: _, sourceUrl: __, contentType: ___ })=>/*#__PURE__*/ _jsx(SheetArtifactEditor, {
            value: value,
            onChange: onChange
        })
};
